import { combineReducers } from 'redux';
import contactChannels from './reducer-contact-channels';
import query from './reducer-query-params';
import notifier from './reducer-notifier';
import emailForm from './reducer-email-form';
import emailNoIntent from './reducer-email-form-no-intent';
import breadCrumb from './reducer-breadcrumb-items';
import activeCommunityUserCount from './reducer-active-community-user';
import faqId from './reducer-faq';
import topicTree from './reducer-message-topic-tree';
import topicSelect from './reducer-select-topics';
import selectResult from './reducer-topic-select-result';
import activeArticle from './reducer-active-article';
import modal from './reducer-login-modal';
import callUs from './reducer-call-us';
import errors from './reducer-error';
import autoComplete from './reducer-auto-complete';
import searchResult from '../../home/reducers/reducer-search-results';
import helpcenterAlerts from './reducer-helpcenter-alerts';
import chatBot from './reducer-chat-bot';
import user from './reducer-locale';
import location from './reducer-location';
import quickAnswers from './reducer-quick-answers';
import suggestTopics from './reducer-related-topic';
import PPCredit from './reducer-ppc-enable';
import crawlIntentTopic from './reducer-crawl-intent-topic';
import chatInEligibleModal from './reducer-chat-ineligible-modal';
import * as constant from '../constants/ActionTypes';
import contactReason from '../../home/reducers/reducer-top-contact-reason';
import speechRecognition from './reducer-speech-recognition';
import lexaMessage from './reducer-lexa-message';
import stepUp from './reducer-step-up';
import postChatBotEligibility from './reducer-postchatbot-eligibility';
import config from '../../refundHelp/reducers/reducer-config-setup';
import app from '../../home/reducers/reducer-app';
import disputeTransactions from '../../home/reducers/reducer-dispute-transactions';
import popularArticles from '../../home/reducers/reducer-popular-list';
import covidBcp from './reducer-covid-bcp';
import trackers from '../../common/trackerAlerts/reducer-trackers';
import ocp from '../../common/ocpCardPrompt/reducer-ocpComponent';
import ocpContextResponse from './reducer-ocp-context';
// Contact US V2
import contactV2Reducers from '../../../jsV2/contactUs/store/rootReducer';

const appReducer = combineReducers({
  contactChannels,
  query,
  notifier,
  searchResult,
  smcResultKeeper: selectResult, // HACK: user redux-persist to keep user select topic tree info
  breadCrumb,
  emailForm,
  persistEmailForm: emailForm, // HACK
  emailNoIntent,
  activeCommunityUserCount,
  activeArticle,
  faqId,
  topicTree,
  topicSelect,
  selectResult,
  callUs,
  errors,
  autoComplete,
  helpcenterAlerts,
  modal,
  user,
  chatBot,
  location,
  persistLocation: location, // HACK: record the channel steering onleave page
  quickAnswers,
  suggestTopics,
  PPCredit,
  crawlIntentTopic,
  chatInEligibleModal,
  contactReason,
  speechRecognition,
  lexaMessage,
  stepUp,
  persistedStepUp: stepUp,
  postChatBotEligibility,
  config, // initial config data, imported from refund help reducer
  app, // For getting the ELMO Experiments
  disputeTransactions, // for disputes
  popular: popularArticles, // for recommended solutions
  covidBcp, // COVID-19 BCP MESSAGE MODAL WINDOW,
  trackers,
  ocp,
  ocpContextResponse,
  ...contactV2Reducers, // setting new contactus redesgin
});

const rootReducers = (state, action) => {
  if (action.type === constant.LOGOUT || action.type === constant.LOCALE_CHANGED) {
    const modalSave = state.modal; // Saving modal info to invoke live/bot chat
    const persistedStepUp = state.persistedStepUp; // Saving step-up info to invoke step-up
    state = { modal: modalSave, persistedStepUp }; // eslint-disable-line no-param-reassign
  }
  return appReducer(state, action);
};
export default rootReducers;
